import { z } from "zod";

/**
 * Single source of truth for the account password policy.
 *
 * Consumed by the React-Hook-Form client rule (`passwordValidation`) AND enforced
 * server-side in `api/setPassword`. Keeping both on these constants prevents the
 * client and server policies from drifting (previously the client enforced strength
 * but the server did not, so a direct API call could set a 1-character password).
 */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 60;
// Requires at least one digit, one lowercase, and one uppercase letter.
export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

export const PASSWORD_MIN_MESSAGE = `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`;
export const PASSWORD_MAX_MESSAGE = `Password cannot be longer than ${PASSWORD_MAX_LENGTH} characters`;
export const PASSWORD_COMPLEXITY_MESSAGE = "Password must contain at least one uppercase letter, one lowercase letter, and one number";

export const PasswordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, PASSWORD_MIN_MESSAGE)
  .max(PASSWORD_MAX_LENGTH, PASSWORD_MAX_MESSAGE)
  .regex(PASSWORD_PATTERN, PASSWORD_COMPLEXITY_MESSAGE);
